module.exports = __webpack_public_path__ + "img/3.62166c2.62166c26.png";